module.exports = __webpack_public_path__ + "static/img/sorrow4.54da64c8.png";